import { render } from "./PermissonCardView.vue?vue&type=template&id=19ef4220"
import script from "./PermissonCardView.vue?vue&type=script&lang=js"
export * from "./PermissonCardView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__